// eslint-disable-next-line max-len
const FOCUSABLE_ELEMENTS = ['a[href]', 'area[href]', 'input:not([disabled])', 'select:not([disabled])', 'textarea:not([disabled])', 'button:not([disabled])', 'iframe', 'object', 'embed', '[contenteditable]', '[tabindex]:not([tabindex^="-"])'];

function getFocusableElements(parent) {
    return [...parent.querySelectorAll(FOCUSABLE_ELEMENTS.join(','))];
}

function makeUntabbable(el) {
    if (el.hasAttribute('tabindex')) {
        el.setAttribute('data-tabindex', el.getAttribute('tabindex'));
    }

    el.setAttribute('tabindex', -1);
}

function makeTabbable(el) {
    if (el.hasAttribute('data-tabindex')) {
        el.setAttribute('tabindex', el.getAttribute('data-tabindex'));
    } else {
        el.removeAttribute('tabindex');
    }
}

function disableTabs(parent) {
    const elements = getFocusableElements(parent);

    elements.forEach(makeUntabbable);
}

function enableTabs(parent) {
    const elements = getFocusableElements(parent);

    elements.forEach(makeTabbable);
}

export {
    disableTabs,
    enableTabs,
};
